var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShellsLogoHorizontalWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 856.3",
    style: {
      enableBackground: "new 0 0 2048 856.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#04222E;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_12_);}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_13_);}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_14_);}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_15_);}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_16_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "e143ae51-3470-4d3a-97bb-c1e324d13877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e545882f-945c-4f9f-a4f9-78de2c5c49a7"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.7,549.4l20-44.2c27.1,14.3,55.6,21.4,85.6,22.8c20,0,30-7.1,30-18.5c0-5.7-2.9-11.4-8.6-14.3 c-11.4-5.7-24.3-11.4-37.1-14.3c-21.4-4.3-40-12.8-58.5-24.3c-17.1-11.4-27.1-30-27.1-49.9c0-18.5,8.6-35.7,22.8-47.1 c18.5-14.3,42.8-21.4,65.6-20c34.2,1.4,68.5,8.6,99.9,22.8l-20,44.2c-25.7-11.4-52.8-17.1-81.3-20c-18.5,0-28.5,7.1-28.5,17.1 c0,10,8.6,17.1,42.8,27.1c21.4,5.7,42.8,14.3,61.4,25.7c17.1,10,28.5,30,27.1,49.9c0,18.5-10,35.7-24.3,47.1 c-20,14.3-42.8,21.4-67.1,20C706.7,576.5,671.1,566.6,639.7,549.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1093.4,409.6v164.1h-61.4V431c0-22.8-8.6-34.2-34.2-34.2c-21.4,1.4-41.4,7.1-59.9,15.7v162.7h-61.4V249.8 h61.4v115.6c25.7-14.3,54.2-22.8,84.2-24.3C1069.2,341.1,1093.4,363.9,1093.4,409.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1353.1,485.2h-159.8c5.7,28.5,31.4,47.1,59.9,44.2c24.3-1.4,48.5-5.7,69.9-17.1l18.5,42.8 c-30,14.3-62.8,21.4-95.6,21.4c-31.4,1.4-61.4-10-82.8-32.8s-32.8-54.2-31.4-85.6c-1.4-31.4,10-62.8,31.4-85.6 c21.4-21.4,51.4-34.2,82.8-32.8c30-1.4,59.9,11.4,79.9,35.7c18.5,25.7,28.5,58.5,27.1,89.9V485.2z M1191.9,442.4h105.6 c-4.3-37.1-20-54.2-49.9-54.2S1196.2,409.6,1191.9,442.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1393.1,509.5V249.8h61.4v251.1c0,14.3,7.1,21.4,20,21.4c4.3,0,10,0,15.7-1.4l4.3,51.4 c-11.4,1.4-21.4,2.9-32.8,2.9C1404.5,576.5,1393.1,535.2,1393.1,509.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1528.6,509.5V249.8h61.4v251.1c0,14.3,7.1,21.4,20,21.4c4.3,0,10,0,15.7-1.4l4.3,51.4 c-11.4,1.4-21.4,2.9-32.8,2.9C1540,576.5,1528.6,535.2,1528.6,509.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1651.3,549.4l20-44.2c27.1,14.3,55.6,21.4,85.6,22.8c20,0,30-7.1,30-18.5c0-5.7-2.9-11.4-8.6-14.3 c-11.4-5.7-24.3-11.4-37.1-14.3c-21.4-4.3-40-12.8-58.5-24.3c-17.1-11.4-27.1-30-27.1-49.9c0-18.5,8.6-35.7,22.8-47.1 c18.5-14.3,42.8-21.4,65.6-20c34.2,1.4,68.5,8.6,99.9,22.8l-20,44.2c-25.7-11.4-52.8-17.1-81.3-20c-18.5,0-28.5,7.1-28.5,17.1 c0,10,8.6,17.1,42.8,27.1c21.4,5.7,42.8,14.3,61.4,25.7c17.1,10,28.5,30,27.1,49.9c0,18.5-10,35.7-24.3,47.1 c-20,14.3-42.8,21.4-67.1,20C1718.4,576.5,1682.7,566.6,1651.3,549.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1942.4,215.5V227h-32.8v87h-11.4v-87h-32.8v-11.4H1942.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2048,314h-11.4l-2.9-79.9l-25.7,55.6c-1.4,2.9-2.9,4.3-5.7,4.3c-2.9,0-4.3-1.4-5.7-4.3l-25.7-55.6l-2.9,78.5 h-11.4l2.9-91.3c0-4.3,4.3-8.6,8.6-8.6l0,0c2.9,0,7.1,1.4,8.6,4.3l27.1,57.1l27.1-57.1c1.4-2.9,4.3-4.3,8.6-4.3 c4.3,0,8.6,2.9,8.6,8.6l0,0L2048,314z"
  })), /*#__PURE__*/React.createElement("g", null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.1,564.3c-55.8-45-91.3-111.2-96.3-183.3c-2.6-46.1,8.2-92.1,31.4-132.4 c51.2-84.8,141.6-138.4,240.3-139.8c71.6-3.5,142.9,19.8,200,63.5l13.9,11.3c4.1,3,6.6,8,7.4,13.3c0.8,5.3-0.9,10.6-4.7,14.4 L411,298.1c9.1,8,17.8,17.5,25.9,26.1c88.1,90,99.8,221.4,23.3,317.2c-101.8,127.1-294.5,144-420.3,43.4L26,673.5 c-7.9-6.8-10-18.4-3-27l0.2-0.8L95.1,564.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.1682,
    y1: -4.1209,
    x2: 218.2329,
    y2: 189.26,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52BD15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A0E35D"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.1,296.4l84.4-96.7c-50.2-39-112.6-58.6-176.5-55.9C142.4,149.3,30.5,250.4,37.4,378.5 c5.5,73.1,46.6,140.2,110.9,177.1c32.9,20,70.1,29.6,108.2,28.6c85-3.3,157-62.1,162-144.3c3.8-76-57.3-153.8-142.7-141.4 c-52.2,8.2-95.8,46.8-97,99.3c-0.3,31.8,14.5,61,39.4,80l6.8-7.9l15-17.8c-11.7-10.5-17.8-25.1-17.7-41 c1-34.1,29.4-59.2,61.9-58.7c40.4,2.3,70.4,36.4,68.6,75.2c-0.2,3.3-0.2,5.8-1.2,8.8c-7,42.2-43.4,71.4-85.3,71.2 c-21.2,0.6-42.7-5.5-59.7-17.8c-29.7-22.3-46.8-57.2-46.5-94c0.2-10.8,1.9-21.2,5.3-31.8c3.2-9.9,7.2-19.5,12.7-28.6 c5.5-9.1,12.3-17,19.5-23.8c7.5-7.6,16.1-13.2,25.4-18.6c9.3-5.4,19.1-9.7,29.4-13.1c10.3-3.3,21.9-5.4,33-6 c14.6-1.1,29,1.1,42.9,4.8C341,283.7,355.2,289.2,367.1,296.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.6999,
    y1: 347.5309,
    x2: 526.6667,
    y2: 100.332,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52BD15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A0E35D"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M138.3,573.4l-72.6,83.7c50,39.8,113.9,59.8,178,56.4c73.7-2,145.6-34.8,191.4-92.8l1.5-2 c17-21.3,30.2-46.4,37.6-71.6c14.9-71.5-7-145.8-58.6-198.7c23.2,36.9,30.8,80.5,19.5,123c-19.9,79.1-93.5,129.8-176.7,132.8 C216,605.4,174.3,594.4,138.3,573.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 519.6361,
    y1: 126.6391,
    x2: 261.8631,
    y2: 355.9748,
    gradientTransform: "matrix(0.9997 2.738307e-02 -2.738307e-02 0.9997 -91.6314 315.9931)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65,656.9c49.4,38.8,122,65.8,204.4,54.9l2.8-109c-52.7,7.2-99.5-8.9-134.9-28.9L65,656.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.3187,
    y1: 85.0342,
    x2: 194.6348,
    y2: 161.2748,
    gradientTransform: "matrix(0.9999 1.074736e-02 -1.074736e-02 0.9999 -83.0118 316.9894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.4,411.5c25.7,106.5,108.4,146.1,108.4,146.1l56.1-66.5c-45.6-32.5-47.7-85.2-47.7-85.2L43.4,411.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.5638,
    y1: 132.6052,
    x2: 260.958,
    y2: -110.9734,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M182.9,328.6c22.5-30.4,59.7-49.3,97-53.1l-0.6-131.9c0,0-124.1-2.7-202.9,105L182.9,328.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.6841,
    y1: 214.6726,
    x2: 159.4721,
    y2: -3.7339,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M182.9,328.6L75.7,248.4c-33.8,46.9-46.2,105.8-33,162.9l116.8-5.6C156.7,378,167.1,348.7,182.9,328.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.7216,
    y1: -35.9571,
    x2: 353.3596,
    y2: 66.5313,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M389.3,346.2c-26.5-35.7-69.1-53.5-113.5-47.7c-52.2,8.2-95.6,46-96.7,98.5c-0.3,31.8,14.5,61,39.4,80l4-4.6 c-32.5-36.6-34.2-98.4,5.2-126.7c65.8-47.4,144.5-8.3,167.9,61.5c7.7,25.2,12.7,51.1,14.1,77.6c17.9-44.5,10.7-94.9-18-135.4 L389.3,346.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.6166,
    y1: 103.4528,
    x2: 434.3755,
    y2: 352.0547,
    gradientTransform: "matrix(1 -1.037745e-02 1.037745e-02 1 -66.8818 314.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.4,711.3c60.2-7.2,124.6-39.9,161.6-86.6l3-4.1c14.3-18,27-39,34.7-60L417,514.1 c-28.2,47.9-85.5,82-143.5,87.5L270.4,711.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.7321,
    y1: 15.4358,
    x2: 571.951,
    y2: 212.5323,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M416.2,513.8l52.8,46.6c1-3,3.2-9.9,4.2-12.9c15.7-71.2-6.5-147.3-58.3-199.4c23.2,36.9,31.3,81.5,20,124 C430.2,486.5,423.9,500.4,416.2,513.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.0877,
    y1: 597.311,
    x2: 345.3643,
    y2: 221.7471,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65,656.9c50,39.8,113.9,59.8,178,56.4c73.7-2,146.8-36,191.4-92.8l1.5-2c17-21.3,30.2-46.4,37.6-71.6 c2.7-8.3,3.4-18.2,3.9-27.3c0.4-9.1,0.9-18.2,0.6-27.5c-0.6-18.7-4-36.6-9.2-54.2c-5.9-17.9-13.6-35.5-23.5-51.3 c-8.2-13.6-18.3-26.1-29.8-37.4c1.8,2.3,4.1,5.5,5.6,8.5c12,17.3,21.9,35.7,29.6,55.8c7.2,19.1,11.4,39.8,11.5,60 c0,0,0,0-0.2,0.8c-0.2,0.8,0.5,1,0.3,1.8c0.6,8.6,0.1,17.7-1.1,26.5s-1.6,17.9-4.4,26.3c-7.2,24.5-19.6,47.3-34.9,65.8l-1.5,2 c-43.8,52-107.9,84-176.5,85.9c-56.2,2.6-112.6-14.9-158-48.2L65,656.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.9489,
    y1: 32.1726,
    x2: 185.3854,
    y2: 496.6956,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M242.1,628.2c91.8-3.6,171.9-58.9,193.3-145.1c11.8-46.5,9.8-86.6-20.6-135.1c22.7,35.9,30.8,80.5,19.5,123 c-19.9,79.1-92.3,128.5-176.7,132.8c-41.9,2.3-87.9-11-119.3-30.5l-21.5,24.9C155.3,619.2,198.7,630,242.1,628.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.6321,
    y1: 70.0624,
    x2: 436.1399,
    y2: -140.4771,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M279.2,275.3l-0.6-131.9c64.3-1.7,124.7,18.9,172.9,56.4l-84.4,96.7C339.8,279.9,304.4,272.6,279.2,275.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.7932,
    y1: -89.5128,
    x2: 335.5044,
    y2: 36.7902,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M451.5,199.7c-50.2-39-112.6-58.6-176.5-55.9C142.4,149.3,30.5,250.4,37.4,378.5 c5.5,73.1,46.6,140.2,110.9,177.1c24.6,14.7,52.4,24.6,81.7,27.5c7.3,0.7,14.9,0.7,22.5,0.6C159.6,580.3,80.1,497.3,74.9,405 c-6-112.7,92.3-200.7,207-205.2c48.4-1.8,96.2,11.2,137.2,37.2L451.5,199.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 824.3978,
    y1: 803.4794,
    x2: 526.8115,
    y2: 695.1992,
    gradientTransform: "matrix(0.9514 0.3078 -0.3078 0.9514 -27.0885 -380.5996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M412.2,477.3c-4,12.1-15.7,32.6-15.7,32.6c-17.5,25.3-34.6,39.1-57.2,51.8s-46.8,20-72.5,21.7 c-22.4,1.9-44.4-0.2-65.4-5.4c-4.6-1.5-9.3-2.2-13.9-3.7c-13.7-4.5-26.6-11.2-39.5-17.9c-12.7-7.5-24.1-16.2-35.2-25.8 c-10.4-9.3-19.8-19-27.9-30.1c-1.8-2.3-2.8-4.3-4.6-6.5c-1.8-2.3-3.6-4.5-5.3-6.8c9.2,10.5,19.6,19.8,30.2,28.3 c6.1,4.5,12.2,9,19.3,13c2.8,1.7,6.3,3.7,9.1,5.5c4.3,2.2,8.6,4.5,12.4,5.7c2.3,0.7,4.3,2.2,7.3,3.2c3.8,1.2,8.1,3.5,12.6,5 c3,1,6.1,2,9.9,3.2c6.1,2,12.4,3.2,18.7,4.4c28.5,5.1,57.8,2.9,84.5-4.3c1-0.5,2.8-0.8,3.5-0.5c4.5-1,9.3-2.8,14.1-4.6 c33.7-13.3,61.3-41.3,73.7-79.2c18.8-57.6-6.3-119.5-57.2-148.7c-7.8-4.2-15.7-8.5-24.8-11.4l-0.8-0.2c-6.8-2.2-12.9-3.7-22.1-6 c1.5,0.1,4.8-1.2,6.4-1.3c1.9-0.1,4.1-0.7,6-0.9c3.9-0.5,7.2-0.7,11.1-0.8c13.6-0.4,28.1,1.5,41,5.8 c15.3,5.1,30.7,14.3,42.9,24.8c10.2,8.7,18.5,20,25.5,31.5c3.6,6,7.1,12.5,9.9,18.9c5.4,12.7,7.6,24.9,9.6,38.6 c1.1,7.1,0.7,15.3,0.3,21.8C419.6,449.5,415.9,463.4,412.2,477.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 824.3978,
    y1: 803.4794,
    x2: 526.8115,
    y2: 695.1992,
    gradientTransform: "matrix(0.9514 0.3078 -0.3078 0.9514 -27.0885 -380.5996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M412.2,477.3c-4,12.1-15.7,32.6-15.7,32.6c-17.5,25.3-34.6,39.1-57.2,51.8s-46.8,20-72.5,21.7 c-22.4,1.9-44.4-0.2-65.4-5.4c-4.6-1.5-9.3-2.2-13.9-3.7c-13.7-4.5-26.6-11.2-39.5-17.9c-12.7-7.5-24.1-16.2-35.2-25.8 c-10.4-9.3-19.8-19-27.9-30.1c-1.8-2.3-2.8-4.3-4.6-6.5c-1.8-2.3-3.6-4.5-5.3-6.8c9.2,10.5,19.6,19.8,30.2,28.3 c6.1,4.5,12.2,9,19.3,13c2.8,1.7,6.3,3.7,9.1,5.5c4.3,2.2,8.6,4.5,12.4,5.7c2.3,0.7,4.3,2.2,7.3,3.2c3.8,1.2,8.1,3.5,12.6,5 c3,1,6.1,2,9.9,3.2c6.1,2,12.4,3.2,18.7,4.4c28.5,5.1,57.8,2.9,84.5-4.3c1-0.5,2.8-0.8,3.5-0.5c4.5-1,9.3-2.8,14.1-4.6 c33.7-13.3,61.3-41.3,73.7-79.2c18.8-57.6-6.3-119.5-57.2-148.7c-7.8-4.2-15.7-8.5-24.8-11.4l-0.8-0.2c-6.8-2.2-12.9-3.7-22.1-6 c1.5,0.1,4.8-1.2,6.4-1.3c1.9-0.1,4.1-0.7,6-0.9c3.9-0.5,7.2-0.7,11.1-0.8c13.6-0.4,28.1,1.5,41,5.8 c15.3,5.1,30.7,14.3,42.9,24.8c10.2,8.7,18.5,20,25.5,31.5c3.6,6,7.1,12.5,9.9,18.9c5.4,12.7,7.6,24.9,9.6,38.6 c1.1,7.1,0.7,15.3,0.3,21.8C419.6,449.5,415.9,463.4,412.2,477.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.7932,
    y1: -89.5128,
    x2: 335.5044,
    y2: 36.7902,
    gradientTransform: "matrix(1 7.806314e-03 -7.806314e-03 1 -75.5478 313.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M451.5,199.7c-50.2-39-112.6-58.6-176.5-55.9C142.4,149.3,30.5,250.4,37.4,378.5 c5.5,73.1,46.6,140.2,110.9,177.1c24.6,14.7,52.4,24.6,81.7,27.5c7.3,0.7,14.9,0.7,22.5,0.6C159.6,580.3,80.1,497.3,74.9,405 c-6-112.7,92.3-200.7,207-205.2c48.4-1.8,96.2,11.2,137.2,37.2L451.5,199.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShellsLogoHorizontalWhite);
export default __webpack_public_path__ + "static/media/shells_logo_horizontal_white.138ae39e494d75cccae34e08e3229b41.svg";
export { ForwardRef as ReactComponent };